/**
 * Shared RTK Query polling intervals and options.
 *
 * Badge polls use longer intervals — tab badges do not need sub-minute freshness.
 * Always pair pollingInterval with skipPollingIfUnfocused so backgrounded tabs
 * do not generate overnight API traffic (see INV-1353).
 */

/** Pause RTK Query polling when the browser tab is in the background. */
export const PAUSE_POLLING_WHEN_UNFOCUSED = { skipPollingIfUnfocused: true } as const;

export function pollingOptions(intervalMs: number) {
  return {
    pollingInterval: intervalMs,
    ...PAUSE_POLLING_WHEN_UNFOCUSED,
  } as const;
}

/** Operations tab badges (scheduler / ETL failure indicators in the nav). */
export const OPERATIONS_BADGE_POLL_INTERVAL_MS = 180_000;

/** Failure alert banners inside Operations tabs. */
export const OPERATIONS_FAILURE_ALERT_POLL_INTERVAL_MS = 120_000;

/** Scheduler dashboard "recently active tasks" panel — not a live feed. */
export const SCHEDULER_ACTIVE_TASKS_POLL_INTERVAL_MS = 120_000;

/** Client Management Requests tab badge. */
export const CAMPAIGN_REQUEST_BADGE_POLL_INTERVAL_MS = 180_000;

export const ETL_RUNS_LIST_POLL_INTERVAL_MS = 30_000;
export const ETL_RUN_DETAIL_POLL_INTERVAL_MS = 15_000;

export const DATA_TRANSFER_LIST_POLL_INTERVAL_MS = 30_000;
export const DATA_TRANSFER_RUN_DETAIL_POLL_INTERVAL_MS = 15_000;
export const DATA_TRANSFER_RUN_HISTORY_POLL_INTERVAL_MS = 30_000;
export const DATA_TRANSFER_RUN_HISTORY_ACTIVE_POLL_INTERVAL_MS = 15_000;

export const BILLING_JOB_POLL_INTERVAL_MS = 4_000;

export const SURVEY_SUMMARY_REFRESH_INTERVAL_MS = 5_000;
export const SURVEY_MEDIA_PLAN_REFRESH_INTERVAL_MS = 5_000;
export const SURVEY_RESULTS_SUMMARY_REFRESH_INTERVAL_MS = 30_000;
